export enum SortCriteria {
  Price,
  Distance,
}
